import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appValidatorMessagesTarget]',
  exportAs: 'validatorMessagesTarget',
  standalone: false
})
export class ValidatorTargetDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
